import type { EditorView } from '@atlaskit/editor-prosemirror/view';

import { pluginKey } from '../../common/agentManagedExtensionPluginType';
import { findAgentManagedExtension } from '../../common/utils';
import {
	rerenderAllNodeViews,
	setNodeViewSelectedByLocalId,
} from '../nodeviews/agentManagedExtensionNodeView';

/**
 * While the configure popup is open, ensure the block appears visually
 * selected (border, lozenge) even though focus has moved to the popup.
 *
 * Instead of dispatching a `NodeSelection` transaction (which causes
 * ProseMirror to scroll the document), we directly mark the node view
 * as selected and re-render it.
 *
 * Returns the `view` object expected by the ProseMirror plugin spec.
 */
export const createSelectedWhileConfigOpenView = (editorView: EditorView) => {
	let prevIsConfigOpen = false;

	return {
		update(): void {
			const pluginState = pluginKey.getState(editorView.state);
			const isConfigOpen = pluginState?.isConfigOpen ?? false;

			if (isConfigOpen === prevIsConfigOpen) {
				return;
			}
			prevIsConfigOpen = isConfigOpen;

			if (isConfigOpen) {
				const found = findAgentManagedExtension(editorView.state);
				if (found) {
					const localId = found.node.attrs.localId as string | undefined;
					if (localId) {
						setNodeViewSelectedByLocalId(localId, true);
						rerenderAllNodeViews();
					}
				}
			}
		},
	};
};
